import differenceInYears from 'date-fns/differenceInYears';
import { LOAN_APPROVAL_AGE } from '../../config/membersArea';

export default function isAdult(date: string): boolean {
    const age = differenceInYears(new Date(), new Date(date));

    return (age >= LOAN_APPROVAL_AGE);
}
